export default __webpack_public_path__ + "static/media/Olga Ferrario_.42e3e83f.png";